const Home = () => {
  return (
    <div className="no-select">
      <h1>Dashboard</h1>
    </div>
  );
};

export default Home;
